import { render, staticRenderFns } from "./ShareFooter.vue?vue&type=template&id=18a7217b&scoped=true&"
import script from "./ShareFooter.vue?vue&type=script&lang=js&"
export * from "./ShareFooter.vue?vue&type=script&lang=js&"
import style0 from "./ShareFooter.vue?vue&type=style&index=0&id=18a7217b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a7217b",
  null
  
)

export default component.exports